<script setup>
import {useField} from 'vee-validate';
import {toTypedSchema} from "@vee-validate/zod";
import {simpleUrl} from "@/customValidation";

defineProps({
  placeholder: {
    type: String,
    default: 'Type here',
  },
  validationSchema: {
    type: Object,
    required: false,
    default: () => null,
  },
  label: {
    type: [String, null],
    required: false,
    default: null,
  },
});

const inputValue = defineModel({
  type: [String],
  required: true,
});

const emit = defineEmits(['submit']);

const {
  errorMessage,
  handleReset,
  setErrors,
} = useField('input', toTypedSchema(simpleUrl), {syncVModel: true});

defineExpose({
  errorMessage,
  setErrors
});

const handleBlur = () => {
  if (!inputValue.value) {
    handleReset();
  }
};
</script>

<template>
  <div class="tw-relative tw-w-full">
    <div class="tw-flex tw-flex-col tw-w-full tw-gap-2">
      <label
        v-if="label"
        for="input"
        class="tw-text-font-neutral-900 tw-font-bold tw-text-base"
      >
        {{ label }}
      </label>

      <input
        v-model="inputValue"
        :placeholder="placeholder"
        class="tw-h-13 tw-border tw-text-neutral-900 tw-self-stretch tw-px-6 tw-text-lg tw-w-full tw-rounded-lg"
        :class="{
          'tw-border-danger' : errorMessage,
          'focus-within:tw-border-primary tw-border-neutral' : !errorMessage,
        }"
        type="text"
        name="input"
        @keyup.enter="emit('submit')"
        @blur="handleBlur"
      >
    </div>
    <p
      v-if="errorMessage"
      class="tw-text-sm tw-text-danger tw-left-0 tw-mt-1 tw-absolute"
    >
      {{ errorMessage }}
    </p>
  </div>
</template>
